/**
 * Hook para gerenciar seleção de profissionais
 */

import { useState, useEffect, type Dispatch, type SetStateAction } from "react";
import type { PublicProvider } from "../types";
import { getPublicProviders } from "../../../services/public";

interface UseProviderSelectionProps {
  slug: string | null;
  selectedServiceId?: string;
  date?: string;
  selectedProviderId: string;
  setSelectedProviderId: Dispatch<SetStateAction<string>>;
}

export function useProviderSelection({
  slug,
  selectedServiceId,
  date,
  selectedProviderId,
  setSelectedProviderId,
}: UseProviderSelectionProps) {
  const [providers, setProviders] = useState<PublicProvider[]>([]);

  useEffect(() => {
    if (!slug) {
      setProviders([]);
      setSelectedProviderId("");
      return;
    }

    getPublicProviders(slug, selectedServiceId || undefined, date || undefined)
      .then((list) => {
        setProviders(list || []);
        // Mantém seleção se o provedor ainda existe, senão volta para "qualquer"
        setSelectedProviderId((prev) =>
          (list || []).some((p) => p.id === prev) ? prev : ""
        );
      })
      .catch(() => setProviders([]));
  }, [slug, selectedServiceId, date, selectedProviderId, setSelectedProviderId]);

  const selectedProvider = providers.find((p) => p.id === selectedProviderId);

  return {
    providers,
    selectedProviderId,
    selectedProvider,
    setSelectedProviderId,
  };
}
